import type { CcLandingConfig, environments } from "./types";

export const ccLandingConfig: Record<environments, CcLandingConfig> = {
  local: {
    launchDarklyKey: "644841c41384731244c27357",
    gtmAccountId: "GTM-5DL26DD",
    newRelic: {
      accountID: "1759997",
      trustKey: "1190893",
      agentID: "1134327616",
      licenseKey: "319ccf429e",
      applicationID: "1134327616"
    },
    pendo: {
      apiKey: "53e0835b-8f53-4c01-45c0-e277be49f4d5"
    }
  },
  qa: {
    launchDarklyKey: "644841c41384731244c27357",
    gtmAccountId: "GTM-5DL26DD",
    newRelic: {
      accountID: "1759997",
      trustKey: "1190893",
      agentID: "1134327616",
      licenseKey: "319ccf429e",
      applicationID: "1134327616"
    },
    pendo: {
      apiKey: "53e0835b-8f53-4c01-45c0-e277be49f4d5"
    }
  },
  prod: {
    launchDarklyKey: "644841c41384731244c27358",
    gtmAccountId: "GTM-5DL26DD",
    newRelic: {
      accountID: "1759997",
      trustKey: "1190893",
      agentID: "1134511612",
      licenseKey: "319ccf429e",
      applicationID: "1134511612"
    },
    pendo: {
      apiKey: "53e0835b-8f53-4c01-45c0-e277be49f4d5"
    }
  }
};
